import { Component, OnInit, Injector, ViewChild, ViewEncapsulation } from '@angular/core';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DataTable } from 'primeng/components/datatable/datatable';
import { Paginator } from 'primeng/components/paginator/paginator';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { LazyLoadEvent } from 'primeng/components/common/lazyloadevent';
import { FileDownloadService } from '@shared/utils/file-download.service';
import { CouponsServiceProxy, EventsServiceProxy } from '@shared/service-proxies/service-proxies';
import { CreateOrEditCouponGroupModalComponent } from '@app/event/coupon-groups/modal/create-or-edit-coupon-group-modal.component';

import * as moment from 'moment';

@Component({
  templateUrl: './coupon-groups.component.html',
  encapsulation: ViewEncapsulation.None,
  animations: [appModuleAnimation()]
})
export class CouponGroupsComponent extends AppComponentBase {

  @ViewChild('createOrEditCouponGroupModal') createOrEditCouponGroupModal: CreateOrEditCouponGroupModalComponent;
  @ViewChild('dataTable') dataTable: DataTable;
  @ViewChild('paginator') paginator: Paginator;

  //Filters
  filterText = '';
  filterUsed = undefined;
  filterEvent = undefined;
  filterResponsible = undefined;
  filterBeginExpirationDate = undefined;
  filterEndExpirationDate = undefined;
  advancedFiltersAreShown = false;

  events = [];
  responsibles = [];

  downloadingExcel = false;

  constructor(
    injector: Injector,
    private _couponsService: CouponsServiceProxy,
    private _fileDownloadService: FileDownloadService,
    private _eventsService: EventsServiceProxy
  ) {
    super(injector);
  }

  getCouponGroups(event?: LazyLoadEvent) {
    if (this.primengDatatableHelper.shouldResetPaging(event)) {
      this.paginator.changePage(0);

      return;
    }

    if(!this.filterBeginExpirationDate && this.filterEndExpirationDate) {
      this.message.warn(this.l("You must select {0} in Advanced Filters.", this.l("Begin Expiration Date")));
    }
    else if(this.filterBeginExpirationDate && !this.filterEndExpirationDate) {
      this.message.warn(this.l("You must select {0} in Advanced Filters.", this.l("End Expiration Date")));
    }
    else if(this.filterBeginExpirationDate && this.filterEndExpirationDate && (this.filterBeginExpirationDate.diff(this.filterEndExpirationDate) > 0)) {
      this.message.warn(this.l("The {0} must be bigger than {1} in Advanced Filters.", this.l("End Expiration Date"), this.l("Begin Expiration Date")));
    }
    else {

      this.primengDatatableHelper.showLoadingIndicator();

      this._couponsService.getAllCouponGroup(
        this.filterText,
        this.filterEvent ? this.filterEvent.id : undefined,
        this.filterResponsible ? this.filterResponsible.id : undefined,
        this.filterUsed,
        this.filterBeginExpirationDate,
        this.filterEndExpirationDate,
        this.primengDatatableHelper.getSorting(this.dataTable),
        this.primengDatatableHelper.getSkipCount(this.paginator, event),
        this.primengDatatableHelper.getMaxResultCount(this.paginator, event)
      )
      .finally(() => {
        this.primengDatatableHelper.hideLoadingIndicator();
      })
      .subscribe(result => {
        this.primengDatatableHelper.totalRecordsCount = result.totalCount;
        this.primengDatatableHelper.records = result.items;
      });
    }
  }

  reloadPage(): void {
    this.paginator.changePage(this.paginator.getPage());
  }

  clear(): void {
    this.filterText = '';
    this.filterUsed = undefined;
    this.filterEvent = undefined;
    this.filterResponsible = undefined;
    this.filterBeginExpirationDate = undefined;
    this.filterEndExpirationDate = undefined;
  }

  createCouponGroup(): void {
    this.createOrEditCouponGroupModal.show();
  }

  deleteCouponGroup(couponGroup: any): void {
    let msg = this.l('Coupon Group') + ' ' + couponGroup.name + ' ' + this.l('will be deleted.');

    this.message.confirm(
      msg,
      (isConfirmed) => {
        if (isConfirmed) {
          this._couponsService.deleteCouponGroup(couponGroup.id)
            .subscribe(() => {
              this.reloadPage();
              this.notify.success(this.l('SuccessfullyDeleted'));
            });
        }
      }
    );
  }

  exportToExcel(): void {

    this.downloadingExcel = true;

    this._couponsService.getCouponGroupsToExcel(
      this.filterText,
      this.filterEvent ? this.filterEvent.id : undefined,
      this.filterResponsible ? this.filterResponsible.id : undefined,
      this.filterUsed,
      this.filterBeginExpirationDate,
      this.filterEndExpirationDate,
    )
    .finally(() => {
      this.downloadingExcel = false;
    })
    .subscribe(result => {
        this._fileDownloadService.downloadTempFile(result);
    });
  }

  // Get Responsibles
  filterResponsibles(event): void {
    this._couponsService.getResponsiblesForSelect(
          event.query,
          undefined,
          20,
          0
        ).subscribe(result => {
        this.responsibles = result.items;
    });
  }

  // Get Events
  filterEvents(event): void {
    this._eventsService.getEventsForSelect(event.query, 0, undefined, undefined, undefined, undefined, undefined, undefined, undefined, 10, 0).subscribe(result => {
        this.events = result.items;
    });
  }

  // Update Begin Expiration Date Filter
  upadateFilterBeginExpirationDate(value: string) {
    this.filterBeginExpirationDate = value ? moment(value, 'L') : undefined;
  }

  // Update End Expiration Date Filter
  upadateFilterEndExpirationDate(value: string) {
    this.filterEndExpirationDate = value ? moment(value, 'L') : undefined;
  }
}



// WEBPACK FOOTER //
// ./src/app/event/coupon-groups/coupon-groups.component.ts